export interface IWindowSize {
  width: Number | number;
  height: Number | number
};

export default defineNuxtPlugin({
  name: 'window',
  dependsOn: [
    'nuxt:global-components',
    'nuxt:router',
    'nuxt-site-config:init',
  ],
  parallel: true,
  enforce: 'post',
  async setup(nuxtApp: any) {
    const size = useState<IWindowSize>('window-size', () => ({
      width: (import.meta.client ? window.innerWidth : 0),
      height: (import.meta.client ? window.innerHeight : 0)
    } as IWindowSize));
    // Window resize
    const handleResize = (): void => {
      if  (import.meta.client)
        size.value = {
          width: window.innerWidth,
          height: window.innerHeight,
        };
    };
    // Computed size
    const styleSize = computed<'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'none' | null | undefined>((): 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'none' | null | undefined => {
      if ((size?.value?.width >= 1536) || (size?.value?.height >= 1536))
        return '2xl';
      else if ((size?.value?.width >= 1280) || (size?.value?.height >= 1280))
        return 'xl';
      else if ((size?.value?.width >= 1024) || (size?.value?.height >= 1024))
        return 'lg';
      else if ((size?.value?.width >= 768) || (size?.value?.height >= 768))
        return 'md';
      else if ((size?.value?.width >= 640) || (size?.value?.height >= 640))
        return 'sm';
      else
        return 'none';
    });
    // Usage
    await nuxtApp.vueApp?.use({
      install(app: any, options: any) {
        app.provide('windowSize', size as Ref<IWindowSize>);
        app.provide('styleSize', styleSize as ComputedRef<String | string>);
      },
    });
    // App
    nuxtApp.hook('app:mounted', () => {
      if (import.meta.client) {
        window.addEventListener('resize', handleResize);
        handleResize();
      }
    });
    nuxtApp.hook('app:unmounted', () => {
      if (import.meta.client)
        window.removeEventListener('resize', handleResize);
    });

    return {
      provide: {
        windowSize: size as Ref<IWindowSize>,
        styleSize: styleSize as ComputedRef<String | string>,
      },
    };
  },
  env: {
    islands: true
  }
});
